// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
// eslint-disable-next-line
const images = require.context('../images', true);
// eslint-disable-next-line
const imagePath = (name) => images(name, true);

import Rails from '@rails/ujs';
import * as ActiveStorage from '@rails/activestorage';
import registerPublicReactComponents from '../src/javascript/public/register_public_react_components';

Rails.start();
ActiveStorage.start();
document.addEventListener('DOMContentLoaded', () => {
  registerPublicReactComponents();
});
